// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const finneon: PokeData = {
  "id": 456,
  "name": "finneon",
  "height": 4,
  "weight": 70,
  "base_experience": 66,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "pound",
    "gust",
    "water-gun",
    "hydro-pump",
    "bubble",
    "flail",
    "attract",
    "safeguard",
    "rain-dance",
    "whirlpool",
    "silver-wind",
    "bounce",
    "water-pulse",
    "roost",
    "tailwind",
    "u-turn",
    "aqua-ring",
    "air-slash",
    "captivate",
    "soak"
  ],
  "moves": [
    "gust",
    "hydro-pump",
    "bubble",
    "rain-dance",
    "whirlpool",
    "roost",
    "tailwind",
    "air-slash",
    "water-spout",
    "aqua-jet",
    "liquidation",
    "bubble-beam",
    "brine"
  ],
  "evolution_chain": {
    "id": 237,
    "item": null,
    "species": [
      {
        "name": "finneon",
        "order": 476,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lumineon",
        "order": 477,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 456,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 31,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 53.75,
    "speed": 66,
    "ability_power": 49
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
